<template>
  <section class="course-tiles-widget grid">
    <div class="wrapper grid">
      <div class="heading-wrapper">
        <WidgetHeading
          class="title t-h3"
          :is-first="isFirst"
          :content="widget.title"
        />
        <CourseTilesNavigation type="desktop" />
      </div>
      <p class="description t-p-m-160" v-html="nbsp(widget.description)" />
      <CourseTilesNavigation type="mobile" />
    </div>
    <Swiper
      :key="`${props.widget.courses.length}-${breakpoint}`"
      slides-per-view="auto"
      class="course-tiles-swiper"
      :navigation="{
        prevEl: `#${widgetId} .navigation-buttons--${breakpoint} .navigation-button--prev`,
        nextEl: `#${widgetId} .navigation-buttons--${breakpoint} .navigation-button--next`
      }"
    >
      <CourseTiles :course-tiles="widget.courses" />
    </Swiper>
  </section>
</template>

<script setup lang="ts">
import { useMediaQuery } from '@vueuse/core'

import type { PublicCourseTilesWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicCourseTilesWidget>>()

const widgetId = computed(() => `widget-${props.widget.id}`)
const isSmallDesktop = useMediaQuery('(min-width: 1024px)')
const breakpoint = computed(() => (isSmallDesktop.value ? 'desktop' : 'mobile'))
</script>

<style scoped lang="scss">
.wrapper {
  @include column(xs, all);
  padding-bottom: rem(32px);

  @include media-up(s-lg) {
    padding-bottom: rem(54px);
  }
}

.heading-wrapper {
  @include media-column(
    (
      xs: 12,
      s-lg: 6 0
    )
  );
}

.title,
.description {
  padding-bottom: rem(38px);
}

.description {
  @include media-column(
    (
      xs: 12,
      s-lg: 6 6
    )
  );

  @include media-up(s-lg) {
    padding-bottom: 0;
  }
}

.course-tiles-swiper {
  @include column(xs, all);
  @include space-around-paddings;
  width: 100%;
  overflow-clip-margin: rem(24px);

  &:deep(.swiper-wrapper) {
    display: flex;
    flex-direction: row;
    gap: rem(24px);
  }
}
</style>
